module.exports = __webpack_public_path__ + "static/media/footer_1.5921bf00.webp";